import { OcrElement } from "../types"

export const OCR_PAGE_WIDTH = 650
export const OCR_PAGE_HEIGHT = 1200

export const getOcrImageDimensions = (el: OcrElement) => {
  const bbox = el.fix_width_bbox || el.bbox
  if (!bbox) {
    return { maxWidth: 280, maxHeight: 180 }
  }

  const [xMin, yMin, xMax, yMax] = bbox
  const maxWidth = Math.max((xMax - xMin) * OCR_PAGE_WIDTH, 50)
  const maxHeight = Math.max((yMax - yMin) * OCR_PAGE_HEIGHT, 20)

  return { maxWidth, maxHeight }
}

export const getOcrImageStyle = (el: OcrElement): string => {
  const { maxWidth, maxHeight } = getOcrImageDimensions(el)
  return `display:block;max-width:${maxWidth}px;max-height:${maxHeight}px;width:auto;height:auto;object-fit:contain;`
}

export const getOcrFigureStyle = (el: OcrElement): string => {
  const { maxWidth, maxHeight } = getOcrImageDimensions(el)
  return `display:inline-block;max-width:${maxWidth}px;max-height:${maxHeight}px;margin:8px 0;`
}
